import { render, staticRenderFns } from "./nameify.vue?vue&type=template&id=17fdf3ea&scoped=true&"
import script from "./nameify.vue?vue&type=script&lang=js&"
export * from "./nameify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fdf3ea",
  null
  
)

export default component.exports